namespace Guid {
    export const empty = '00000000-0000-0000-0000-000000000000';
    export const guidRegExTemplate = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
    const bracedGuid = /^\{(.*)\}$/;
    const regEx = new RegExp(`^${guidRegExTemplate}$`, 'i');

    // tslint:disable:no-bitwise
    function getNumber(placeholder: string): number {
        switch (placeholder) {
            case 'M':
                return 4;
            case 'N':
                return (Math.random() * 4) | 0x8;
            default:
                return (Math.random() * 16) | 0;
        }
    }

    // tslint:enable:no-bitwise

    function getChar(placeholder: string): string {
        return getNumber(placeholder).toString(16);
    }

    export function newGuid(): Guid {
        return _.replace('xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx', /[xMN]/g, getChar) as Guid;
    }

    export function isGuid(value: any, allowBraces: boolean = false): value is Guid {
        if (!value) {
            return false;
        }
        value = allowBraces ? value.replace(bracedGuid, '$1') : value;
        return value === empty || regEx.test(value);
    }

    export function isGuidValue(value: any, allowBraces: boolean = false): value is Guid {
        return isGuid(value, allowBraces) && !value.contains(empty);
    }

    export function parse(str: string): Guid {
        if (isGuid(str)) {
            return str;
        }
        throw new Error(str);
    }
}

export default Guid;
